module.exports = __webpack_public_path__ + "static/media/scr_onboarding_logo_ios.de654912.png";